import { render, staticRenderFns } from "./BySlider.vue?vue&type=template&id=045ba893&scoped=true"
import script from "./BySlider.vue?vue&type=script&lang=js"
export * from "./BySlider.vue?vue&type=script&lang=js"
import style0 from "./BySlider.vue?vue&type=style&index=0&id=045ba893&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045ba893",
  null
  
)

export default component.exports